import { EMPTY_SITE_DATA } from 'components/AssignLicense/data'

const mapAddressToFormData = address => ({
  city: address?.city ?? '',
  country: address?.country ?? '',
  region: address?.region ?? '',
})

export const mapNetSuiteCustomerToAssignFormData = customer => {
  const address = customer?.address ?? {}

  return {
    ...mapAddressToFormData(address),
    netSuiteCustomerId: customer?.id ?? '',
    nsCustomerId: customer?.nsCustomerId || '',
    siteName: customer?.companyName || '',
  }
}

export const mapSiteToAssignFormData = (site, fallbackName = '') => {
  if (!site) {
    const siteName = fallbackName ?? ''

    return {
      ...EMPTY_SITE_DATA,
      netSuiteCustomerId: siteName ? 0 : '',
      siteName,
    }
  }

  const address = site.address ?? {}
  const siteName = site.name || fallbackName || ''
  const nsCustomerId =
    site.netSuiteCustomer?.nsCustomerId || site.nsCustomerId || ''
  const netSuiteCustomerId = site.netSuiteCustomer?.id

  const resolvedSiteName =
    nsCustomerId && netSuiteCustomerId
      ? siteName || site.netSuiteCustomer?.companyName || ''
      : siteName

  let resolvedNetSuiteCustomerId = ''
  if (nsCustomerId && netSuiteCustomerId) {
    resolvedNetSuiteCustomerId = netSuiteCustomerId
  } else if (!nsCustomerId && siteName) {
    resolvedNetSuiteCustomerId = 0
  }

  return {
    ...mapAddressToFormData(address),
    netSuiteCustomerId: resolvedNetSuiteCustomerId,
    nsCustomerId: nsCustomerId || '',
    siteName: resolvedSiteName,
  }
}

const getReassignSiteData = (license, sites = []) => {
  const siteId = license?.site?.id
  if (!siteId) {
    return EMPTY_SITE_DATA
  }

  const site = sites.find(({ id }) => id === siteId)

  return mapSiteToAssignFormData(site, license?.site?.name)
}

export const isReassignSiteMissingFromSitesMe = (license, sites = []) => {
  const siteId = license?.site?.id
  if (!siteId) {
    return false
  }

  return !sites.some(({ id }) => id === siteId)
}

export default getReassignSiteData
